var _rect, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagPhilippinesDestination(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#5754E5",
    strokeOpacity: 0.15
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16213_325055",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 34,
    height: 34
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16213_325055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.60547 1H66.3945V18H-1.60547V1Z",
    fill: "#0038A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.60547 18H66.3945V35H-1.60547L-1.60547 18Z",
    fill: "#CE1126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8393 18L-1.60547 35V1L27.8393 18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.97031 21.4C10.8481 21.4 12.3703 19.8777 12.3703 18C12.3703 16.1222 10.8481 14.6 8.97031 14.6C7.09254 14.6 5.57031 16.1222 5.57031 18C5.57031 19.8777 7.09254 21.4 8.97031 21.4Z",
    fill: "#FCD116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.97263 18L7.77734 11.99L8.13434 11.6326L8.97263 18ZM8.97263 18L8.53101 11.2639L8.97263 10.8223L9.41425 11.2639L8.97263 18ZM8.97263 18L9.81092 11.6326L10.1679 11.99L8.97263 18Z",
    fill: "#FCD116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.97268 18L10.168 24.01L9.81097 24.3674L8.97268 18ZM8.97268 18L9.4143 24.7361L8.97268 25.1777L8.53106 24.7361L8.97268 18ZM8.97268 18L8.13439 24.3674L7.77739 24.01L8.97268 18Z",
    fill: "#FCD116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.97066 18L14.9807 16.8047L15.3381 17.1617L8.97066 18ZM8.97066 18L15.7068 17.5584L16.1484 18L15.7068 18.4416L8.97066 18ZM8.97066 18L15.3381 18.8383L14.9807 19.1953L8.97066 18Z",
    fill: "#FCD116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.97075 18L2.96068 19.1953L2.6033 18.8383L8.97075 18ZM8.97075 18L2.23459 18.4416L1.79297 18L2.23459 17.5584L8.97075 18ZM8.97075 18L2.6033 17.1617L2.96068 16.8047L8.97075 18Z",
    fill: "#FCD116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.96896 18L12.3735 12.905L12.8787 12.9048L8.96896 18ZM8.96896 18L13.4199 12.9245L14.0444 12.9245L14.0444 13.5491L8.96896 18ZM8.96896 18L14.0642 14.0903L14.0639 14.5954L8.96896 18Z",
    fill: "#FCD116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.96854 18L5.56398 23.095L5.05884 23.0952L8.96854 18ZM8.96854 18L4.51763 23.0755L3.89308 23.0755L3.89308 22.4509L8.96854 18ZM8.96854 18L3.87332 21.9097L3.87358 21.4046L8.96854 18Z",
    fill: "#FCD116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.96997 18L14.0649 21.4045L14.0652 21.9097L8.96997 18ZM8.96997 18L14.0454 22.4509L14.0454 23.0754L13.4209 23.0754L8.96997 18ZM8.96997 18L12.8797 23.0952L12.3745 23.0949L8.96997 18Z",
    fill: "#FCD116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.97143 17.9999L3.87648 14.5953L3.87621 14.0902L8.97143 17.9999ZM8.97143 17.9999L3.89598 13.549L3.89598 12.9245L4.52053 12.9245L8.97143 17.9999ZM8.97143 17.9999L5.06173 12.9047L5.56687 12.905L8.97143 17.9999Z",
    fill: "#FCD116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4365 17.9999L23.1589 18.4442L23.1313 19.7963L22.3142 18.7185L21.0195 19.1102L21.7921 17.9999L21.0195 16.8897L22.3142 17.2814L23.1313 16.2036L23.1589 17.5557L24.4365 17.9999Z",
    fill: "#FCD116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0952045 32.0553L0.349281 30.7267L-0.807854 30.0268L0.534114 29.858L0.842166 28.541L1.41743 29.7651L2.76524 29.6512L1.77865 30.5766L2.30349 31.8231L1.11877 31.171L0.0952045 32.0553Z",
    fill: "#FCD116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0932637 3.94463L1.11683 4.82897L2.30155 4.17682L1.77671 5.42337L2.7633 6.34869L1.41549 6.23478L0.840226 7.45898L0.532173 6.14191L-0.809795 5.97315L0.34734 5.27323L0.0932637 3.94463Z",
    fill: "#FCD116"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagPhilippinesDestination);
export default __webpack_public_path__ + "static/media/flagPhilippinesDestination.9e5705292f98ab9ccd26c653d04666c3.svg";
export { ForwardRef as ReactComponent };